import { useMemo } from 'react'
import Highlighter from 'react-highlight-words'
import styled from 'styled-components'

import Box from 'components/Box'
import Icon from 'components/Icon'
import Text from 'components/Text'
import Tooltip from 'components/Tooltip'
import { colors } from 'utils/colors'
import { Flex } from 'components'
import { useTranslation } from 'react-i18next'

type ResultType = 'contact_name' | 'email' | 'mobile' | 'company' | 'company_reg_no' | 'address' | 'account_name'

export type SearchResultsRowItemProps = {
  type: ResultType
  value: string
  searchTerm: string
}

const SearchResultsRowItem = ({ type, value, searchTerm }: SearchResultsRowItemProps) => {
  const { t } = useTranslation()
  const iconMetaData = useMemo(() => {
    switch (type) {
      case 'contact_name':
        return { tooltip: t('contact_name_lbl'), icon: ['far', 'user'] }
      case 'email':
        return { tooltip: t('contact_email_lbl'), icon: ['far', 'envelope'] }
      case 'mobile':
        return { tooltip: t('mobile_number_lbl'), icon: ['far', 'phone'] }
      case 'company':
        return { tooltip: t('company_name_lbl'), icon: ['far', 'building'] }
      case 'company_reg_no':
        return { tooltip: t('reg_no_lbl'), icon: ['far', 'briefcase'] }
      case 'address':
        return { tooltip: t('address_lbl'), icon: ['far', 'map-marker-alt'] }
    }
  }, [type])

  return (
    <Wrapper display="flex" alignItems="center" pb="6px">
      <Tooltip title={`${iconMetaData?.tooltip} : ${value}`} position="bottom">
        <Flex flexDirection="row" gap="8px">
          <Box width="16px" display="flex" justifyContent="center">
            {iconMetaData?.icon && <Icon icon={iconMetaData.icon} color="gray5" />}
          </Box>
          <Text display={'inline-block'} fontSize={13} color="gray5" maxWidth="455px">
            <Highlighter
              searchWords={[searchTerm]}
              autoEscape={true}
              textToHighlight={value}
              highlightStyle={{ backgroundColor: 'white', color: colors.green2 }}
            />
          </Text>
        </Flex>
      </Tooltip>
    </Wrapper>
  )
}

const Wrapper = styled(Box)`
  :not(:first-of-type) {
    margin-left: 16px;
  }
`

export default SearchResultsRowItem
